module.exports = __webpack_public_path__ + "media/assets/images/flags/cl-49a74b0cba468d21f2d88279f1d5a9fb.svg";